import * as THREE from 'three';
import p5 from "p5";
import { QTreeDispQuad } from './QTreeDispQuad';
import { QTreeRect } from '../myP5/drawer/QTreeRect';
import { Params } from '../data/Params';


export class QTreeDispQuads extends THREE.Object3D {

    private _quads:QTreeDispQuad[];
    private _visible:boolean=true;

    constructor(){
        
        super();

    }

    init(rects:QTreeRect[]){

        //console.log(rects)

        if(this._quads!=null){
            for(let i=0;i<this._quads.length;i++){
                this._quads[i].kill();
                this.remove( this._quads[i] );
            }
        }

        this._quads=[];

        for(let i=0;i<rects.length;i++){

            let rect = rects[i];
            let q = new QTreeDispQuad();
            q.position.set(
                rect.x/512*128-128/2,
                -rect.y/512*128+128/2,
                10
            );
            q.scale.set(
                rect.w/512*128,
                rect.h/512*128,
                1
            );
            q.init(rect)

            this.add(q);
            this._quads.push(q);

        }

        //Params.gui.add(this,"showLines");
        //Params.gui.add(this,"hideLines");
        
        document.addEventListener('keydown', (event) => {
            const keyName = event.key;
            if(keyName=="l"){
                this.toggleLines();
            }
        });

    }   

    toggleLines(){

        if(this._visible){
            this.hideLines()
        }else{
            this.showLines()
        }

    }

    showLines(){
        this._visible=true;
        for(let i=0;i<this._quads.length;i++){
            this._quads[i].visible=true;
        }
    }
    hideLines(){
        this._visible=false;
        for(let i=0;i<this._quads.length;i++){
            this._quads[i].visible=false;            
        }
    }


    update(){

        for(let i=0;i<this._quads.length;i++){
            this._quads[i].update();
        }

    }

    resize(x:number,y:number,w:number,h:number){

        let dom = document.getElementById("domContainer");
        let dom2 = document.getElementById("domContainer2");
        dom.style.position = "absolute";
        dom.style.left  = x+"px";
        dom.style.top   = y+"px";
        dom.style.transformOrigin = "0 0";
        dom.style.zIndex = "999"
        let scaleX = w/512;
        let scaleY = h/512;
        dom.style.transform = "scale("+scaleX+","+scaleY+")";
        
        dom2.style.position = "absolute";
        dom2.style.left  = x+"px";
        dom2.style.top   = y+"px";
        dom2.style.transformOrigin = "0 0";
        dom2.style.zIndex = "1000"
        dom2.style.transform = "scale("+scaleX+","+scaleY+")";        


        //console.log("resize!!! " + scaleX + " " + scaleY);
        
    }

}